import { render, staticRenderFns } from "./DestaquesApenasImagem.vue?vue&type=template&id=2df660f2&scoped=true&"
import script from "./DestaquesApenasImagem.vue?vue&type=script&lang=js&"
export * from "./DestaquesApenasImagem.vue?vue&type=script&lang=js&"
import style0 from "./DestaquesApenasImagem.vue?vue&type=style&index=0&id=2df660f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df660f2",
  null
  
)

export default component.exports